import { render, staticRenderFns } from "./Donation.vue?vue&type=template&id=56459ac8&scoped=true"
import script from "./Donation.vue?vue&type=script&lang=js"
export * from "./Donation.vue?vue&type=script&lang=js"
import style0 from "./Donation.vue?vue&type=style&index=0&id=56459ac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56459ac8",
  null
  
)

export default component.exports